import client from './client';

/** Uploads a claim photo, returning the iGard-side attachment id. */
export async function saveAttachment(claimId, filename, data) {
  const response = await client.post('/api/care-portal/attachments', {
    claimId,
    filename,
    data,
  });

  return { attachmentId: response.data.attachmentId };
}
